
import React from 'react'
import { IoAdd } from 'react-icons/io5';
import { useLocation, useNavigate } from 'react-router-dom';
import styled, { css } from 'styled-components';
import tw from 'twin.macro';
import { api } from '../../../api';
import browserRoutes from '../../../common/browserRoutes';
import styles from '../../../common/styles';
import { useMatchScreen } from '../../../App';

type Props = {}

const CreatePostButton = (props: Props) => {
  const location = useLocation();
  const navigate = useNavigate();

	const screenMdMatch = useMatchScreen('md')

	const createPostLinkVisibility = () => {
		if (location.pathname.includes(browserRoutes.createPost())) return false;
		return true;
	};

	const handleCreatePostButtonClick = () => {
		api.get("/").then(() => {
			navigate(browserRoutes.createPost());
		});
	};

	if (!createPostLinkVisibility()) return null

	return (
    <Button onClick={handleCreatePostButtonClick}>
      {screenMdMatch && <span>Create post</span>}
      <IoAdd />
    </Button>
  );
}

const Button = styled.button(() => [
  tw`flex px-1 space-x-0.5 items-center font-thin text-pink-600`,
	styles.border,
  tw`aspect-square md:(aspect-auto)`,
	css`
    margin-right: auto;
    font-size: 0.5rem;
    svg {
      ${tw`mb-[0.05rem] mx-auto`}
    }
  `,
]);

export default CreatePostButton

function useScrenMatch() {
	throw new Error('Function not implemented.');
}
